import { ElementRef, forwardRef } from 'react';
import { Separator, DropdownMenuSeparatorProps as BaseProps } from '@radix-ui/react-dropdown-menu';

import { cn } from 'styles';

export type DropdownMenuSeparatorProps = Pick<BaseProps, 'className'>;

export const DropdownMenuSeparator = forwardRef<
  ElementRef<typeof Separator>,
  DropdownMenuSeparatorProps
>(({ className, ...props }, ref) => (
  // This negative margin is related to the p-1 the content has by default
  // On future revisions, adjust this to make em' both related explicitly
  <Separator ref={ref} className={cn('-mx-1 my-1 h-px shrink-0 bg-muted', className)} {...props} />
));

DropdownMenuSeparator.displayName = Separator.displayName;
